export { IndexTemplate, type TodayFortuneTellingResult } from './IndexTemplate';
